import { Directive, ElementRef } from "@angular/core";

@Directive({
    selector: "[upperCase]",
    host: {
        '(input)': "toUpperCase($event.target.value)"
    }

})
export class UpperCaseDirective {
    constructor(private readonly ref: ElementRef) {
    }
    
    // ReSharper disable once TsResolvedFromInaccessibleModule
    toUpperCase(value: string) {
        this.ref.nativeElement.value = value.toUpperCase();
    }
}